// React
import React from 'react';
import { Button, Modal, ModalHeader, Label, Col, Input } from 'reactstrap';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

export const ModalShowHistoric = ({ isOpen, toggle, historic, handleBack }) => {
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      performedByInput: historic ? historic.performed_by : '',
      hasChangesInput: historic ? historic.has_changes : false,
      historyInput: historic ? historic.history : '',
    },
    validationSchema: Yup.object({
      performedByInput: Yup.string().required(),
      hasChangesInput: Yup.boolean().nullable(),
      historyInput: Yup.string(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        performed_by: values.performedByInput || null,
        has_changes: values.hasChangesInput,
        history: values.historyInput || null,
      };
    },
  });

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      centered
    >
      <ModalHeader>Histórico</ModalHeader>
      <div className="modal-body">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit(e);
          }}
        >
          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="performedByInput" className="form-label">
                Visita realizada por
              </Label>
              <Input
                disabled
                type="text"
                id="performedByInput"
                value={validation.values.performedByInput || ''}
              />
            </div>
          </Col>

          <Col md={12}>
            <div className="mb-3">
              <Input
                disabled
                type="checkbox"
                className="me-2"
                id="hasChangesInput"
                value={validation.values.hasChangesInput}
                checked={validation.values.hasChangesInput}
              />
              <Label for="hasChangesInput" className="form-label">
                Houve atualização
              </Label>
            </div>
          </Col>

          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="historyInput" className="form-label">
                Detalhes da Visita
              </Label>
              <Input
                disabled
                aria-multiline
                type="textarea"
                id="historyInput"
                className="form-control"
                value={validation.values.historyInput}
                style={{
                  height: 100,
                }}
              />
            </div>
          </Col>
          <div className="text-end">
            <Button
              color="light"
              onClick={() => {
                handleBack();
              }}
            >
              Voltar
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
